export default {
  invalidOptionCountAnnually: 'Count must be between 1 and 12.',
  invalidOptionCountContract: 'Count must not exceed number of months.',
  invalidOptionCountQuarterly: 'Count must be between 1 and 3.',
  invalidOptionCountSemiAnnually: 'Count must be between 1 and 6.',
  invalidOptionCountWholeNumber: 'Count must be a whole number.',
  invalidNotificationPeriod: 'Must be a positive number.',
  invalidVolume: 'Must be a positive number.',
  invalidNumber: 'Must be a valid number.',
  requiredField: 'This field is required.',
};
